import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { TwoFactorService } from '../../../services/twofactor.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login-email',
  templateUrl: './login-email.component.html',
  styleUrls: ['../login.component.css'],
  imports: [CommonModule],
  standalone:true
})
export class LoginEmailComponent implements OnInit {
  rememberMe!: number | 0;
  errorMessage: any = "";
  verificationCode: any = "";
  userEmail: any = "";
  userEmailMask: any = "";
  isMobile = false;

  constructor(
    private twoFactorService: TwoFactorService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      console.log("Received params", params);

      this.rememberMe = (params['remember'] == '1') ? 1 : 0;

      this.userEmail = JSON.parse(sessionStorage.getItem('wOSUser')!).email;
      this.userEmailMask = 'xxxx' + this.userEmail!.slice(this.userEmail!.indexOf('@') - 3);
      this.twoFactorService.send2FAEmail(this.userEmail).then(r => {
        $('#2fa_confirm').trigger('focus');
      });
    });
  }

  resendCode(): any {
    this.twoFactorService.send2FAEmail(this.userEmail).then(r => {
      this.errorMessage = "The 2FA Code has been resent to your email " + this.userEmailMask;
    })
  }

  backToChooser(): any {
    this.router.navigate(['login'], { queryParams: { mode: '2fa' } });
  }

  confirmCode(): any {
    const code = $('#2fa_confirm').val();
    this.verificationCode = code;

    this.twoFactorService.verifyCode(this.userEmail, this.verificationCode).then(r => {
      console.log("Code confirmed", r);
      if (r == 1) {
        this.twoFactorService.updateUserRecord(this.userEmail,this.rememberMe).then(r => {
          this.router.navigate(['dashboard']);
        })

        
      } else {
        this.errorMessage = "The 2FA Code is incorrect.  Please try again.";
      }
    })
  }
}
